import { defineStore } from 'pinia'
import { getWechatAuthUrl, getUserInfoByCode, bindPhoneWithToken } from '@/utils/api'


/**
 * 认证状态管理Store
 * 管理用户认证状态、微信授权流程和绑定流程
 */
export const useAuthStore = defineStore('auth', {
  state: () => ({
    // 用户信息
    token: localStorage.getItem('user_token') || null,
    //是否绑定手机号
    is_bind: localStorage.getItem('is_bind') || false,
    // 流程状态
    isProcessing: false, // 是否正在处理中（授权或绑定）
    showAuthLoading: false, // 是否显示授权加载状态
    showBindForm: false, // 是否显示绑定表单
    // 错误信息
    error: null, // 错误信息对
  }),

  getters: {
    // 检查是否已微信授权
    isWechatAuthorized: (state) => state.token,
    
    // 获取用户昵称（用于显示）
    userNickname: (state) => state.userInfo?.nickname || '微信用户',

    // 检查token是否有效
    isTokenValid: (state) => {
      return state.token && state.tokenExpire && Date.now() < state.tokenExpire
    },
    //检查是否绑定手机号
    isBindPhone:(state) => !!state.is_bind,
   
  },

  actions: {
    /**
     * 设置处理中状态
     * @param {Boolean} status - 是否处理中
     */
    setIsProcessing(status) {
      this.isProcessing = status
    },
    
    /**
     * 设置授权加载状态
     * @param {Boolean} status - 是否显示授权加载
     */
    setShowAuthLoading(status) {
      this.showAuthLoading = status
    },
    
    /**
     * 设置绑定表单显示状态
     * @param {Boolean} status - 是否显示绑定表单
     */
    setShowBindForm(status) {
      this.showBindForm = status
    },
    
    /**
     * 设置错误信息
     * @param {String} message - 错误消息
     */
    setError(message) {
      this.error = message
      // 3秒后自动清除错误信息
      setTimeout(() => {
        this.error = null
      }, 3000)
    },
    
    /**
     * 存储用户信息
     * @param {Object} userInfo - 用户信息对象
     */
    setUserInfo(userInfo) {
      this.token = userInfo.token
      this.is_bind = userInfo.is_bind,
      //持久化存储user_id
      localStorage.setItem('is_bind', userInfo.is_bind)
      //持久化token
      localStorage.setItem('user_token', userInfo.token)
    },

    //绑定手机号
    setIsBindPhone(){
      this.is_bind = true
      //持久化存储
      localStorage.setItem('is_bind',true)
    },
    
    /**
     * 启动微信授权流程
     * @param {String} redirectUri - 前端回调地址（绑定页面URL）
     */
    async startWechatAuth(redirectUri) {
      try {
        // 设置处理中状态
        this.setIsProcessing(true)
        this.setShowAuthLoading(true)
        this.setError(null)
        
        // 调用API获取微信授权URL
        const response = await getWechatAuthUrl(redirectUri)
        
        // 检查响应状态
        if (response.code !== 0) {
          throw new Error(response.message || '获取授权链接失败')
        }
        
        // 跳转到微信授权页面
        window.location.href = response.data.authUrl
      } catch (error) {
        // 错误处理
        alert(error.message)
        this.setError(error.message || '授权失败，请稍后再试')
        this.setIsProcessing(false)
        this.setShowAuthLoading(false)
      }
    },
    
    /**
     * 使用授权code获取用户信息
     * @param {String} code - 微信授权返回的code
     */
    async getUserInfoByCode(code) {
      try {
        // 设置处理中状态
        this.setIsProcessing(true)
        this.setError(null)
        
        // 调用API获取用户信息
        const response = await getUserInfoByCode(code)
        
        // 检查响应状态
        if (response.code !== 0) {
          throw new Error(response.message || '获取用户信息失败')
        }
        
        // 存储用户信息
        this.setUserInfo(response.data)
        
        // 显示绑定表单
        this.setShowBindForm(true)
      } catch (error) {
        // 错误处理
        this.setError(error.message || '获取用户信息失败')
      } finally {
        this.setIsProcessing(false)
      }
    },
    
    /**
     * 绑定手机号
     * @param {String} phone - 用户手机号
     */
    async bindPhoneNumber(phone) {
      try {
        
        // 校验手机号格式
        if (!/^1[3-9]\d{9}$/.test(phone)) {
          throw new Error('请输入有效的11位手机号码')
        }
        
        // 准备绑定数据
        const bindData = {
          phone: phone
        }
        
        // 调用绑定接口
        const response = await bindPhoneWithToken(bindData)
        
        // 检查响应状态
        if (response.code !== 0) {
          throw new Error(response.message || '绑定失败')
        }
        
        // 绑定成功处理
        this.setShowBindForm(false)
        this.setIsBindPhone();
        
        // 跳转到会员中心或首页
        window.location.href ="https://dev.henandingbu.top/#/member-center/"
      } catch (error) {
        // 错误处理
        this.setError(error.message || '绑定失败，请稍后再试')
      } finally {
        this.setIsProcessing(false)
      }
    },
      /**
     * 清除用户信息和token
     */
    clearAuth() {
      this.userInfo = null
      this.openid = null
      this.token = null
      this.tokenExpire = null
      localStorage.removeItem('user_openid')
      localStorage.removeItem('user_token')
      localStorage.removeItem('user_token_expire')
    }
  }
})